import z from 'zod';
import { defineObject } from 'sanity-typed-queries';
import callToAction from './callToAction.js';
var schema = defineObject('labeledCallToAction', {
    label: {
        title: 'Label',
        type: 'string',
        validation: function validation(Rule) {
            return Rule.required();
        }
    },
    action: {
        title: 'Action',
        type: 'callToAction',
        validation: function validation(Rule) {
            return Rule.required();
        }
    }
}, [
    callToAction.schema.callToAction
]);
var validator = z.object({
    label: z.string(),
    action: callToAction.validator
}).partial();
schema.labeledCallToAction;
export default {
    schema: schema,
    validator: validator
};

//# sourceMappingURL=labeledCallToAction.js.map